import { StyleSheet } from 'react-native';
import { fontFamily, fontFamilyMedium, grey } from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    width: 200,
    backgroundColor: 'grey',
    height: 20,
    borderRadius: 20,
  },
  counter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 5,
  },
  counterText: {
    color: grey,
    fontFamily: fontFamilyMedium,
  },
  progressStyle: {
    borderRadius: 20,
    height: 6,
  },
  text: {
    fontFamily,
  },
});
